module.exports = __webpack_public_path__ + "static/media/wallfinishes_allImpact_60yd_n.730a31ce.csv";